<template>
  <div>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit(item)">
        <v-card-text>
          <v-text-field
            v-model="item.id"
            type="text"
            label="id"
            hint="The user Id"
            :error-messages="isInvalid('id') ? violations.id : []"
            @input.native="handleUpdateField('id', $event.target.value)"
          ></v-text-field>
          <v-text-field
            v-model="item.username"
            type="text"
            label="username"
            hint="The user username"
            :error-messages="isInvalid('username') ? violations.username : []"
            @input.native="handleUpdateField('username', $event.target.value)"
          ></v-text-field>
          <v-text-field
            v-model="item.email"
            type="text"
            label="email"
            hint="The user email"
            :error-messages="isInvalid('email') ? violations.email : []"
            @input.native="handleUpdateField('email', $event.target.value)"
          ></v-text-field>
          <v-checkbox
            v-model="item.emailVerified"
            label="emailVerified"
            hint="Whether this user email is verified"
            :error-messages="isInvalid('emailVerified') ? violations.emailVerified : []"
            @change.native="handleUpdateField('emailVerified', $event.target.value)"
          ></v-checkbox>
          <v-checkbox
            v-model="item.enabled"
            label="enabled"
            hint="Whether this user is enabled/disabled"
            :error-messages="isInvalid('enabled') ? violations.enabled : []"
            @change.native="handleUpdateField('enabled', $event.target.value)"
          ></v-checkbox>
          <v-text-field
            v-model="item.roleInVessels"
            type="text"
            label="roleInVessels"
            hint="The vessel roles that has a relationship with the user"
            :error-messages="isInvalid('roleInVessels') ? violations.roleInVessels : []"
            @input.native="handleUpdateField('roleInVessels', $event.target.value)"
          ></v-text-field>
          <v-text-field
            v-model="item.roleInOrganizations"
            type="text"
            label="roleInOrganizations"
            hint="The organization roles that has a relationship with the user"
            :error-messages="isInvalid('roleInOrganizations') ? violations.roleInOrganizations : []"
            @input.native="handleUpdateField('roleInOrganizations', $event.target.value)"
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn v-if="item['@id']" text color="red" @click="deleteConfirmShow = true">Delete</v-btn>
          <v-btn :disabled="!valid" text color="primary" type="submit">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-dialog v-model="deleteConfirmShow" max-width="400">
      <v-card>
        <v-card-title class="headline">Delete {{ item.id }}?</v-card-title>
        <v-card-text>
          Are you sure you want to delete {{ item.id }}? <br /><br />
          The deleted data <strong>can't be recovered</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="grey darken-1" text @click.native="onDeleteCancel">Cancel</v-btn>
          <v-btn color="red" text @click.native="onDeleteConfirm">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    handleDelete: {
      type: Function,
      required: false,
      default: () => {}
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      deleteConfirmShow: false,
      valid: true
    }
  },

  computed: {
    // eslint-disable-next-line
            item () {
      return this.initialValues || this.values
    },

    violations() {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid(key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },

    onDeleteConfirm() {
      this.deleteConfirmShow = false
      this.handleDelete()
    },

    onDeleteCancel() {
      this.deleteConfirmShow = false
    },

    onSubmit(item) {
      if (this.$refs.form.validate()) {
        this.handleSubmit(item)
      }
    }
  }
}
</script>
